import type { RegistryEntry } from '../types';

const parseFrameIndexes = (raw: unknown): number[] | undefined => {
    if (typeof raw !== 'string') return undefined;
    const nums = raw
        .split(/[,，\s]+/)
        .map((part) => part.trim())
        .filter(Boolean)
        .map(Number)
        .filter((n) => Number.isInteger(n) && n >= 0);
    return nums.length ? nums : undefined;
};

export const fluxConfigs: Record<string, RegistryEntry> = {
    'flux-3': {
        options: [
            { key: 'audio', label: 'Generate Audio', type: 'switch', default: true, group: 'basic' },
        ],
        toProviderOptions: (ui) =>
            ({
                audio: typeof ui.audio === 'boolean' ? ui.audio : true,
            } as unknown as Record<string, Record<string, any>>),
    },
    'flux-3-keyframes': {
        options: [
            { key: 'audio', label: 'Generate Audio', type: 'switch', default: true, group: 'basic' },
            {
                key: 'frame_indexes',
                label: 'Frame Indexes',
                type: 'input',
                default: '',
                group: 'basic',
                remark: 'Comma-separated frame indexes at 24fps, one per image in order (e.g. 0,48,96). Only applied when the count matches the number of images; otherwise uses 0,1,2,… Max = duration×24−1.',
            },
        ],
        toProviderOptions: (ui) => {
            const frame_indexes = parseFrameIndexes(ui.frame_indexes);
            return {
                audio: typeof ui.audio === 'boolean' ? ui.audio : true,
                ...(frame_indexes ? { frame_indexes } : {}),
            } as unknown as Record<string, Record<string, any>>;
        },
    },
};